import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Leaf, MapPin, MessageCircle, Heart } from "lucide-react";
import { VALUES } from "../../data/content";
import RevealSection from "./RevealSection";
import HiddenMonkey from "./HiddenMonkey";
import { MONKEY_SPOTS } from "./context";

const ICONS = { Sparkles, Leaf, MapPin, MessageCircle, Heart };
const ROTATE = [-1.5, 1, -0.8, 1.4, -1];
const COLLAGE = ["collage tone-cream", "collage collage-2 tone-sage", "collage collage-3 tone-kraft", "collage collage-2 tone-white", "collage collage-3 tone-sage"];

export default function Valors() {
  return (
    <RevealSection id="valors" className="relative px-5 py-24">
      <div className="mx-auto max-w-6xl">
        <header className="mb-14 text-center">
          <span className="font-hand text-2xl font-bold text-terracotta">allò que enganxem al cor</span>
          <h2 className="mt-1 font-display text-4xl font-bold text-forest sm:text-5xl">Els nostres valors</h2>
          <p className="mx-auto mt-3 max-w-xl font-body text-forest/70">
            Cinc valors que impregnen cada espectacle, cada taller i cada decisió.
          </p>
        </header>

        <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {VALUES.map((v, i) => {
            const Icon = ICONS[v.icon];
            return (
              <motion.div
                key={v.id}
                whileHover={{ y: -6, rotate: 0 }}
                initial={{ rotate: ROTATE[i] }}
                transition={{ type: "spring", stiffness: 200, damping: 15 }}
                className={`relative p-8 ${COLLAGE[i]}`}
                data-testid={`value-card-${v.id}`}
              >
                {MONKEY_SPOTS.includes(v.id) && <HiddenMonkey spotId={v.id} />}
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-forest text-paper">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display text-2xl font-semibold text-forest">{v.title}</h3>
                <p className="mt-2 font-body leading-relaxed text-forest/80">{v.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </RevealSection>
  );
}
